import { getUserOrgDeals } from 'api/deals.api';
import { getOrgPipelinesOnFounder } from 'api/founderPipeline.api';
import { getOrgInvestors } from 'api/investors.api';
import { handleToggleExpandAllStageCards } from 'components/global/_helpers/board.events';
import { $filter, $list, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const fetchAndSetInvestorOptionsData = async () => {
  $view.update({ isTabLoading: true });
  try {
    const [{ data: investorData }, { data: dealData }] = await Promise.all([
      getOrgInvestors(),
      getUserOrgDeals(),
    ]);

    const investorOptions = investorData.map((investor) => ({
      label: investor.investorName,
      value: `${investor.recordType}-${investor.investorId}`,
    }));

    const dealOptions = dealData.map((deal) => ({
      label: deal.name,
      value: deal.id,
    }));

    $view.update({
      investorOptions,
      dealOptions,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load filter options. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({ isTabLoading: false }); // Fixed: should be false, not true
  }
};

export const fetchAndSetPipelineData = async ({ initView = null } = {}) => {
  if (initView) {
    $view.update({
      view: initView,
    });
  }
  $filter.reset();
  try {
    const { data } = await getOrgPipelinesOnFounder();

    $list.update({
      data,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load pipeline data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    handleToggleExpandAllStageCards('expand');
  }
};

export const fetchAndSetInvestorData = async () => {
  $view.update({ isTableLoading: true });
  try {
    const { data } = await getOrgInvestors();
    $list.update({
      data,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load investor data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({ isTableLoading: false });
  }
};
